import type { AssignmentSummaryResponse } from '../../api/types';
import styles from './VehicleCell.module.css';

/** Material "local_shipping" (24 px grid, Apache-2.0). */
const TRUCK_PATH =
  'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9 1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z';

/**
 * One cell for every shipment list (#234): truck number first, driver beneath in
 * muted text, "—" until a truck is assigned. Long values truncate; the full text
 * stays in the title.
 */
export function VehicleCell({ assignment }: { assignment: AssignmentSummaryResponse | null | undefined }) {
  const vehicle = assignment?.vehicleRegistrationNumber;
  if (!vehicle) return <span className={styles.none}>—</span>;
  const driver = assignment.driverName;
  return (
    <span className={styles.cell}>
      <span className={styles.vehicleLine} data-line="vehicle">
        <svg
          className={styles.icon}
          width={14}
          height={14}
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
          focusable="false"
        >
          <path d={TRUCK_PATH} />
        </svg>
        <span className={styles.vehicle} title={vehicle}>
          {vehicle}
        </span>
      </span>
      {driver && (
        <span className={styles.driver} data-line="driver" title={driver}>
          {driver}
        </span>
      )}
    </span>
  );
}
